import script from "./detail.vue?vue&type=script&setup=true&name=QualificationDetail&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&name=QualificationDetail&lang=js"

import "./detail.vue?vue&type=style&index=0&id=2b16f6c8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b16f6c8"]])

export default __exports__